export const SUCCESS_DEFAULT = 'neo-trading/dashboard/SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'neo-trading/dashboard/FAILURE_DEFAULT';
export const LOAD_CHANGE_PASSWORD = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD';
export const LOAD_CHANGE_PASSWORD_SUCCESS = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_SUCCESS';
export const LOAD_CHANGE_PASSWORD_FAILURE = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_FAILURE';
export const LOAD_CHANGE_PASSWORD_SETTING = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_SETTING';
export const LOAD_CHANGE_PASSWORD_SETTING_SUCCESS = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_SETTING_SUCCESS';
export const LOAD_CHANGE_PASSWORD_SETTING_FAILURE = 'neo-trading/dashboard/LOAD_CHANGE_PASSWORD_SETTING_FAILURE';
export const BLANK_MSG = 'neo-trading/dashboard/BLANK_MSG';
export const CLOSE_MODAL = 'neo-trading/dashboard/CLOSE_MODAL';
export const FORGOT_PASS = 'neo-trading/dashboard/FORGOT_PASS';
export const FORGOT_PASS_SUCCESS = 'neo-trading/dashboard/FORGOT_PASS_SUCCESS';
export const FORGOT_PASS_FAILURE = 'neo-trading/dashboard/FORGOT_PASS_FAILURE';
export const VERIFY_OTP = 'neo-trading/dashboard/VERIFY_OTP';
export const VERIFY_OTP_SUCCESS = 'neo-trading/dashboard/VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'neo-trading/dashboard/VERIFY_OTP_FAILURE';
export const RESEND_OTP = 'neo-trading/dashboard/RESEND_OTP';
export const RESEND_OTP_SUCCESS = 'neo-trading/dashboard/RESEND_OTP_SUCCESS';
export const RESEND_OTP_FAILURE = 'neo-trading/dashboard/RESEND_OTP_FAILURE';
export const RESET_PASSWORD = 'neo-trading/dashboard/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'neo-trading/dashboard/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'neo-trading/dashboard/RESET_PASSWORD_FAILURE';